import { VaultObjectFilterControllableFactor } from "@/types/vault-object-filter-types";
import React, { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

interface EffectButtonProps {
  children: React.ReactNode;
  factor: VaultObjectFilterControllableFactor;
  isSelected: boolean;
  icon: React.ReactElement;
  onClick: () => void;
  onClose: () => void;
}

export const EffectButton = ({
  children,
  factor,
  isSelected,
  icon,
  onClick,
  onClose,
}: EffectButtonProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => {
    if (isSelected) {
      onClose();
    }
  });

  const buttonClasses = `w-10 h-10 flex items-center justify-center rounded-lg transition-all 
    ${isSelected ? "bg-[var(--gray50)]" : "bg-transparent"} 
    hover:bg-[var(--gray50)] cursor-pointer`;

  return (
    <div ref={ref} className={"relative flex items-center justify-center"}>
      {children}
      <div onClick={onClick} className={buttonClasses}>
        {icon}
      </div>
    </div>
  );
};
